import * as Cookies from "es-cookie"

export const DLogout = async () => {
  Cookies.remove("JWToken")
  const daccountEndpoint = process.env.REACT_APP_DLOGOUT_ENDPOINT
  // URL直叩き対策
  const createLogoutNonce = async () => {
    const crypto = require("crypto")
    const buff = crypto.randomBytes(8)
    const logoutNonce = buff.toString("hex")
    return logoutNonce
  }
  const logoutNonce = await createLogoutNonce()
  const url = `${process.env.REACT_APP_D_AUTH_LOGOUT_NL}/logout?logoutNonce=${logoutNonce}`
  Cookies.set("logoutNonce", logoutNonce)
  const nl = encodeURIComponent(url)

  const logoutRequest = `${daccountEndpoint}?serviceurl=${nl}`
  window.location.href = logoutRequest
}
